import LoginForm from '@/model/user/LoginForm'

export default class LoginRequest {
  userName: string = ''
  password: string = ''

  constructor(loginForm: LoginForm) {
    this.userName = loginForm.userName
    // this.password = md5(loginForm.password)
    this.password = loginForm.password
  }
}
